import { useState } from "react";
import MainLayout from "../layout/MainLayout";

const conversations = [
    { id: 1, title: "Сводка по подбору", period: "Сегодня", active: true },
    { id: 2, title: "Кандидаты без ответа", period: "Вчера" },
    { id: 3, title: "Риски адаптации", period: "2 октября" },
    { id: 4, title: "План найма на октябрь", period: "30 сентября" },
];

const suggestions = [
    {
        title: "Приоритеты на сегодня",
        text: "Какие вакансии и кандидаты требуют внимания сегодня?",
        icon: "spark",
    },
    {
        title: "Сильные кандидаты",
        text: "Покажи кандидатов с оценкой выше 70 и совпадающим городом",
        icon: "people",
    },
    {
        title: "Контроль адаптации",
        text: "У кого из сотрудников просрочен этап адаптации?",
        icon: "route",
    },
    {
        title: "Воронка подбора",
        text: "Подготовь сводку по воронке подбора за этот месяц",
        icon: "chart",
    },
    {
        title: "Пакеты документов",
        text: "Каких документов не хватает у кандидатов с оффером?",
        icon: "document",
    },
    {
        title: "Рабочий план",
        text: "Составь план задач HR на эту неделю",
        icon: "calendar",
    },
];

function LineIcon({ name, className = "h-5 w-5" }) {
    const paths = {
        spark: <><path d="m12 3-1.2 3.3a7 7 0 0 1-4.5 4.5L3 12l3.3 1.2a7 7 0 0 1 4.5 4.5L12 21l1.2-3.3a7 7 0 0 1 4.5-4.5L21 12l-3.3-1.2a7 7 0 0 1-4.5-4.5L12 3Z" /></>,
        people: <><path d="M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20"/><circle cx="10" cy="8" r="3"/><path d="M17 9a2.5 2.5 0 1 0-1.2-4.7M18 13.5a3 3 0 0 1 2 2.8V18"/></>,
        route: <><circle cx="6" cy="6" r="2"/><circle cx="18" cy="18" r="2"/><path d="M8 6h4a4 4 0 0 1 4 4v0a4 4 0 0 1-4 4h-1a4 4 0 0 0-4 4"/></>,
        chart: <><path d="M4 19V9M10 19V5M16 19v-7M22 19H2"/></>,
        document: <><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z"/><path d="M14 3v6h6M8 13h8M8 17h5"/></>,
        calendar: <><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18M8 14h.01M12 14h.01M16 14h.01"/></>,
        plus: <path d="M12 5v14M5 12h14"/>,
        history: <><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5M12 7v5l3 2"/></>,
        paperclip: <path d="m20.5 11.5-8.8 8.8a6 6 0 0 1-8.5-8.5l9.2-9.2a4 4 0 0 1 5.7 5.7l-9.2 9.2a2 2 0 0 1-2.8-2.8l8.5-8.5"/>,
        send: <><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></>,
        shield: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/><path d="m9 12 2 2 4-4"/></>,
        dots: <><circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/></>,
    };
    return (
        <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            {paths[name]}
        </svg>
    );
}

export default function AiAssistantPage() {
    const [draft, setDraft] = useState("");
    const [historyOpen, setHistoryOpen] = useState(false);

    const chooseSuggestion = (text) => setDraft(text);

    return (
        <MainLayout
            className="flex h-[calc(100vh-61px)] flex-col overflow-hidden !p-0"
            contentClassName="h-full w-full max-w-none"
        >
            <section className="relative flex h-full min-h-0 w-full overflow-hidden bg-white" aria-labelledby="ai-assistant-title">
                {historyOpen && (
                    <button
                        type="button"
                        aria-label="Закрыть историю диалогов"
                        className="absolute inset-0 z-20 bg-slate-950/25 lg:hidden"
                        onClick={() => setHistoryOpen(false)}
                    />
                )}

                <aside className={`${historyOpen ? "translate-x-0" : "-translate-x-full"} absolute inset-y-0 left-0 z-30 flex w-[286px] flex-col border-r border-slate-200 bg-slate-50/95 p-4 backdrop-blur transition-transform lg:static lg:translate-x-0`} aria-label="История диалогов">
                    <button type="button" className="flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-800">
                        <LineIcon name="plus" className="h-4 w-4" />
                        Новый диалог
                    </button>

                    <div className="mt-6 flex items-center justify-between px-1">
                        <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">Недавние диалоги</p>
                        <LineIcon name="history" className="h-4 w-4 text-slate-400" />
                    </div>

                    <nav className="mt-3 space-y-1" aria-label="Недавние диалоги">
                        {conversations.map((conversation) => (
                            <button
                                key={conversation.id}
                                type="button"
                                className={`group flex w-full items-center gap-3 rounded-xl px-3 py-3 text-left transition ${conversation.active ? "border border-amber-200 bg-amber-50 text-slate-900 shadow-sm" : "border border-transparent text-slate-600 hover:bg-white hover:text-slate-900"}`}
                            >
                                <span className={`h-2 w-2 shrink-0 rounded-full ${conversation.active ? "bg-[#d3aa30]" : "bg-slate-300"}`} />
                                <span className="min-w-0 flex-1">
                                    <span className="block truncate text-sm font-semibold">{conversation.title}</span>
                                    <span className="mt-0.5 block text-xs text-slate-400">{conversation.period}</span>
                                </span>
                                <LineIcon name="dots" className="h-4 w-4 opacity-0 transition group-hover:opacity-100" />
                            </button>
                        ))}
                    </nav>

                    <div className="mt-auto rounded-2xl border border-slate-200 bg-white p-4">
                        <div className="flex items-start gap-3">
                            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600">
                                <LineIcon name="shield" className="h-5 w-5" />
                            </span>
                            <div>
                                <p className="text-sm font-semibold text-slate-800">Безопасная работа</p>
                                <p className="mt-1 text-xs leading-5 text-slate-500">Консультант будет учитывать права доступа пользователя к данным.</p>
                            </div>
                        </div>
                    </div>
                </aside>

                <div className="flex min-w-0 flex-1 flex-col bg-[radial-gradient(circle_at_top,_rgba(224,187,72,0.10),_transparent_33%)]">
                    <header className="flex items-center justify-between border-b border-slate-100 bg-white/85 px-4 py-3 backdrop-blur sm:px-6">
                        <div className="flex min-w-0 items-center gap-3">
                            <button type="button" aria-label="Открыть историю диалогов" className="rounded-xl border border-slate-200 p-2 text-slate-500 lg:hidden" onClick={() => setHistoryOpen(true)}>
                                <LineIcon name="history" className="h-5 w-5" />
                            </button>
                            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-slate-900 text-[#e0bb48] shadow-sm">
                                <LineIcon name="spark" className="h-5 w-5" />
                            </span>
                            <div className="min-w-0">
                                <h1 id="ai-assistant-title" className="truncate text-base font-bold text-slate-900 sm:text-lg">AI-консультант HR</h1>
                                <p className="truncate text-xs text-slate-500 sm:text-sm">Помощник по подбору и работе с сотрудниками</p>
                            </div>
                        </div>
                        <button type="button" className="rounded-xl border border-slate-200 p-2.5 text-slate-500 transition hover:bg-slate-50" aria-label="Настройки консультанта">
                            <LineIcon name="dots" className="h-5 w-5" />
                        </button>
                    </header>

                    <main className="min-h-0 flex-1 overflow-y-auto px-4 py-8 sm:px-8 lg:px-12">
                        <div className="mx-auto flex min-h-full max-w-4xl flex-col justify-center">
                            <div className="mx-auto max-w-2xl text-center">
                                <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-[22px] bg-slate-900 text-[#e0bb48] shadow-lg shadow-slate-200">
                                    <LineIcon name="spark" className="h-8 w-8" />
                                </span>
                                <h2 className="mt-6 text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">Чем помочь в работе с командой?</h2>
                                <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-slate-500 sm:text-base">Получайте сводки по подбору, находите точки внимания и готовьте рабочие материалы в контексте HR-платформы.</p>
                            </div>

                            <div className="mt-8 grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
                                {suggestions.map((suggestion) => (
                                    <button
                                        key={suggestion.title}
                                        type="button"
                                        onClick={() => chooseSuggestion(suggestion.text)}
                                        className="group rounded-2xl border border-slate-200 bg-white p-4 text-left shadow-sm transition hover:-translate-y-0.5 hover:border-amber-300 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-amber-300"
                                    >
                                        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-600 transition group-hover:bg-amber-50 group-hover:text-amber-700">
                                            <LineIcon name={suggestion.icon} className="h-5 w-5" />
                                        </span>
                                        <span className="mt-3 block text-sm font-bold text-slate-900">{suggestion.title}</span>
                                        <span className="mt-1.5 block text-xs leading-5 text-slate-500">{suggestion.text}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </main>

                    <footer className="border-t border-slate-100 bg-white/90 px-4 py-4 backdrop-blur sm:px-8">
                        <div className="mx-auto max-w-4xl">
                            <div className="rounded-2xl border border-slate-200 bg-white p-2 shadow-[0_10px_35px_rgba(15,23,42,0.08)] focus-within:border-amber-300 focus-within:ring-4 focus-within:ring-amber-100/60">
                                <textarea
                                    value={draft}
                                    onChange={(event) => setDraft(event.target.value)}
                                    rows="2"
                                    aria-label="Вопрос AI-консультанту"
                                    placeholder="Спросите о кандидатах, вакансиях или адаптации…"
                                    className="max-h-32 min-h-[52px] w-full resize-none border-0 bg-transparent px-3 py-2 text-sm leading-6 text-slate-800 outline-none placeholder:text-slate-400"
                                />
                                <div className="flex items-center justify-between gap-3 px-1 pb-1">
                                    <div className="flex min-w-0 items-center gap-2">
                                        <button type="button" disabled title="Вложения будут доступны после подключения AI" className="rounded-xl p-2 text-slate-400 disabled:cursor-not-allowed disabled:opacity-60">
                                            <LineIcon name="paperclip" className="h-5 w-5" />
                                        </button>
                                        <span className="truncate rounded-lg bg-slate-100 px-2.5 py-1.5 text-xs font-semibold text-slate-500">Режим: HR-консультант</span>
                                    </div>
                                    <button type="button" disabled aria-label="Отправить вопрос" title="Отправка появится после подключения backend" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-900 text-white opacity-45 disabled:cursor-not-allowed">
                                        <LineIcon name="send" className="h-4 w-4" />
                                    </button>
                                </div>
                            </div>
                            <p className="mt-2 text-center text-[11px] leading-4 text-slate-400">Сейчас доступен дизайн интерфейса. Ответы и работа с данными будут подключены отдельно.</p>
                        </div>
                    </footer>
                </div>
            </section>
        </MainLayout>
    );
}
